import Divider from '@mui/material/Divider'

const ListItemDivider = ({ index, listLength }) => {
  return index < listLength - 1 && <Divider data-testid="list-item-divider" />
}

export default ListItemDivider
